import { lazy } from "react";
import MiddleBlockContent from "../../content/MiddleBlockContent.json";
import MiddleBlockPolicy from "../../content/MiddleBlockPolicy.json";
import {
  Hero,
  HeroIcon,
  HeroTitle,
  HeroTagline,
  HeroActions,
  StoreLink,
  DocLinks,
  DocLink,
} from "./styles";

const MiddleBlock = lazy(() => import("../../components/MiddleBlock"));
const Container = lazy(() => import("../../common/Container"));

const Home = () => {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Container>
      <Hero>
        <HeroIcon src="/img/icons/CSMainIcon copy4 copy.png" alt="Kontra" />
        <div>
          <HeroTitle>
            Kontra <span>Multiplayer FPS</span>
          </HeroTitle>
          <HeroTagline>
            Zombie survival, deathmatch, arms race, deathrun and surf — online
            on community and official servers.
          </HeroTagline>
          <HeroActions>
            <StoreLink
              href="https://play.google.com/store/apps/details?id=com.gameplier.kontra"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/img/svg/google_play.png" alt="" />
              Google Play
            </StoreLink>
            <StoreLink
              href="https://apps.apple.com/us/app/kontra-multiplayer-fps/id1660215198"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/img/svg/app_store.png" alt="" />
              App Store
            </StoreLink>
            <StoreLink
              href="https://discord.gg/HwVzkMWrxH"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/img/svg/discord.png" alt="" />
              Discord
            </StoreLink>
          </HeroActions>
        </div>
      </Hero>
      <DocLinks>
        <DocLink onClick={() => scrollTo("terms")}>Terms of Service</DocLink>
        <DocLink onClick={() => scrollTo("privacy")}>Privacy Policy</DocLink>
      </DocLinks>
      <MiddleBlock
        id="terms"
        title={MiddleBlockContent.title}
        content={MiddleBlockContent.text}
        button={MiddleBlockContent.button}
      />
      <MiddleBlock
        id="privacy"
        title={MiddleBlockPolicy.title}
        content={MiddleBlockPolicy.text}
        button={MiddleBlockPolicy.button}
      />
    </Container>
  );
};

export default Home;
